import React from 'react';
import { StyledButton } from './Button.styles';

const Button = ({ children, gap, newStyle, lg, outline, variant, width, rounded, loader, disabled, ...rest }) => {
  return (
    <StyledButton
      $lg={lg}
      $newStyle={newStyle}
      $outline={outline}
      $variant={variant}
      $gap={gap}
      $rounded={rounded}
      $width={width}
      disabled={disabled}
      {...rest}>
      {loader ? <span className="loader"></span> : children}
    </StyledButton>
  );
};

export default Button;
